class LottieScrollAnimator {
  constructor(selector) {
    this.players = document.querySelectorAll(selector);
    this.observer = new IntersectionObserver(this.handleIntersection.bind(this), {
      root: null,
      rootMargin: '0px',
      threshold: 0.5 // Adjust the threshold as needed
    });
    this.init();
  }

  init() {
    this.players.forEach(player => {
      this.observer.observe(player);
    });
  }

  handleIntersection(entries, observer) {
    entries.forEach(entry => {
      const player = entry.target;

      if (entry.isIntersecting) {
        player.play();
      } else {
        player.stop();
      }
    });
  }
} export default LottieScrollAnimator
